export default __webpack_public_path__ + "static/media/mobile5.cca0af45.jfif";